module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "intro-editor"
    }
  }, [_c('div', {
    staticClass: "field",
    class: {
      squeezed: _vm.showLabels
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLabels),
      expression: "showLabels"
    }],
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['name']))]), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.name.length && !_vm.isNameValid
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tokens['name'],
      "disabled": !_vm.nameEditable
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.name.length && !_vm.isNameValid),
      expression: "name.length && !isNameValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['name_invalid']))]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLabels),
      expression: "showLabels"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_texts']))])]), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calib),
      expression: "calib"
    }],
    staticClass: "textarea low",
    class: {
      'is-danger': !_vm.isCalibInstructionValid
    },
    attrs: {
      "placeholder": _vm.tokens['ph_calib_inst']
    },
    domProps: {
      "value": (_vm.calib)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.calib = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCalibInstructionValid),
      expression: "!isCalibInstructionValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['msg_instruction_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start),
      expression: "start"
    }],
    staticClass: "textarea low",
    class: {
      'is-danger': !_vm.isStartInstructionValid
    },
    attrs: {
      "placeholder": _vm.tokens['ph_start_inst']
    },
    domProps: {
      "value": (_vm.start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isStartInstructionValid),
      expression: "!isStartInstructionValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['msg_instruction_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstPage),
      expression: "firstPage"
    }],
    staticClass: "textarea",
    class: {
      'is-danger': !_vm.isFirstPageValid
    },
    attrs: {
      "placeholder": _vm.tokens['ph_first_page']
    },
    domProps: {
      "value": (_vm.firstPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstPage = $event.target.value
      }
    }
  })]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFirstPageValid),
      expression: "!isFirstPageValid"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.tokens['msg_instruction_invalid']))]), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.action))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52f54fae"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/IntroEditor.vue
// module id = 420
// module chunks = 0